import Axios, {Method} from "axios";


const instance = Axios.create({
// .. where we make our configurations
  baseURL: 'https://jsonplaceholder.typicode.com'
});

export const callAPI = async <T>( url: string, method?: Method, data?: any ) => {

  return instance({
    url,
    method,
    data
  }).then(resp => {
    return resp.data as T
  });
};
